<template>
  <div class="id-box">
    <!-- Tells password managers which account the password on this step belongs to. -->
    <input type="text" name="username" autocomplete="username" :value="value" readonly hidden />
    <span class="id-box-value">{{ value }}</span>
    <button type="button" class="id-box-change" @click="$emit('change')">Cambiar</button>
  </div>
</template>

<script>
// The identification confirmed in step 1, shown on every later step with a way back to fix it.
export default {
  name: "IdentityBox",
  props: {
    value: { type: String, default: "" },
  },
};
</script>

<style scoped>
.id-box {
  box-sizing: border-box;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 8px 0 16px;
  border: 1px solid #d5d9e0;
  border-radius: 12px;
  background: #f6f7f9;
  font: 15px "IBM Plex Sans", sans-serif;
  color: #1c2434;
}
.id-box-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: 0.02em;
  font-variant-numeric: tabular-nums;
}
.id-box-change {
  flex-shrink: 0;
  height: 36px;
  padding: 0 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font: 600 14px "IBM Plex Sans", sans-serif;
  color: #222a47;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
.id-box-change:hover {
  background: #eceef2;
}
/* Same focus treatment as the rest of the auth screens: none on clicks, a gold ring for keyboard users. */
.id-box-change:focus {
  outline: none;
}
.id-box-change:focus-visible {
  outline: 2px solid #caa651;
  outline-offset: 2px;
}
</style>
